import { createFileRoute, useParams } from '@tanstack/react-router'
import VisualsGallery from '../../../../../../../../../../../containers/pin-details/components/media-and-files/pin-visual-media/visuals-gallery'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType/$planId/$pinId/gallery/$postId/$fileId/'
)({
  component: PinDetailsGalleryRoute
})

function PinDetailsGalleryRoute() {
  const { fileId } = useParams({ strict: false })
  return <VisualsGallery fileId={fileId} />
}
